import {useGetMe} from 'api/generated';

const useMe = () => {
  const {data: meData} = useGetMe({query: {staleTime: Infinity, gcTime: Infinity}});
  return meData?.data?.data;
};

export default useMe;
